export default __webpack_public_path__ + "static/media/hht1_ep04_timeline_q03_b.ae163f0d.png";